import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckCategory } from "../../../utils/enums";
import PeopleResourcesTab from "./PopulationResources/PeopleResourcesTab";
import AWSResourcesTab from "./InfraResources/AWSResourcesTab";
import AzureResourcesTab from "./InfraResources/AzureResourcesTab";
import GCPResourcesTab from "./InfraResources/GCPResourcesTab";
import GenericResourcesTab from "./GenericResources/GenericResourcesTab";

const ResourcesTab = ({ checkDetails, activeCheckId, checkCategory, onRefetch, onStartPolling, globalException, isTriggerDisabled, checkStatus, remediationEnabled = false, isPollingRunStatus, onRegisterRefetch }) => {
  const isPeopleCheck = checkDetails?.active_check_category?.toLowerCase().includes(CheckCategory?.PEOPLE_CHECK)
  const isAWS = checkCategory === CheckCategory?.AWS_SYSTEM_CHECK;
  const isAzure = checkCategory === CheckCategory?.AZURE_SYSTEM_CHECK;
  const isGCP = checkCategory === CheckCategory?.GCP_SYSTEM_CHECK;

  const hasResources = checkDetails?.resources && checkDetails.resources.length > 0;
  const showGenericResources = hasResources && !isPeopleCheck && !isAWS && !isAzure && !isGCP;

  if (isPeopleCheck) {
    return (
      <PeopleResourcesTab 
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        onStartPolling={onStartPolling}
        globalException={globalException}
        isPollingRunStatus={isPollingRunStatus}
      />
    );
  }

  if (isAWS) {
    return (
      <AWSResourcesTab 
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        onStartPolling={onStartPolling}
        globalException={globalException}
        isTriggerDisabled={isTriggerDisabled}
        checkStatus={checkStatus}
        remediationEnabled={remediationEnabled}
        isPollingRunStatus={isPollingRunStatus}
        onRegisterRefetch={onRegisterRefetch}
      />
    );
  }

  if (isAzure) {
    return (
      <AzureResourcesTab 
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        onStartPolling={onStartPolling}
        globalException={globalException}
        isTriggerDisabled={isTriggerDisabled}
        checkStatus={checkStatus}
        remediationEnabled={remediationEnabled}
        isPollingRunStatus={isPollingRunStatus}
        onRegisterRefetch={onRegisterRefetch}
      />
    );
  }

  if (isGCP) {
    return (
      <GCPResourcesTab 
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        onStartPolling={onStartPolling}
        globalException={globalException}
        isTriggerDisabled={isTriggerDisabled}
        checkStatus={checkStatus}
        remediationEnabled={remediationEnabled}
        isPollingRunStatus={isPollingRunStatus}
        onRegisterRefetch={onRegisterRefetch}
      />
    );
  }
  if (showGenericResources) {
    return (
      <GenericResourcesTab 
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        onRefetch={onRefetch}
        onStartPolling={onStartPolling}
        globalException={globalException}
        isPollingRunStatus={isPollingRunStatus}
      />
    );
  }
  return (
    <Box sx={{ p: 0 }}/>
  );
};

export default ResourcesTab;
